import type { TrendItemContentTweetsItemEngagementAllOf } from './trendItemContentTweetsItemEngagementAllOf';
import type { TrendItemContentTweetsItemEngagementAllOfTwo } from './trendItemContentTweetsItemEngagementAllOfTwo';

export type TrendItemContentTweetsItemEngagement = TrendItemContentTweetsItemEngagementAllOf & TrendItemContentTweetsItemEngagementAllOfTwo;
